import {createClient} from '@sanity/client'

// 1o3bsg6z

export const client = createClient({
  projectId: "l3m1tz9l",
  dataset: "main",
  useCdn: true,
});
